import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { LabFinderModalComponent } from '@components/consultation-request/lab-finder-modal/lab-finder-modal.component';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-wellness-panel',
  imports: [UpsellCardComponent, LabFinderModalComponent, NgIf],
  templateUrl: './wellness-panel.component.html',
  styleUrl: './wellness-panel.component.scss',
})
export class WellnessPanelComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.AhWellnessPanel;
  public showLabFinderModal = false;

  /**
   * Toggle the find a lab modal.
   */
  public toggleLabFinderModal() {
    this.showLabFinderModal = !this.showLabFinderModal;
  }
}
